import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LegacyIframeComponent } from './legacy-iframe.component';

@NgModule({
  declarations: [LegacyIframeComponent],
  exports: [LegacyIframeComponent],
  imports: [CommonModule],
})
export class LegacyIframeModule {}
